import { TILE_WIDTH, TILE_HEIGHT } from '../constants';

/**
 * Convert cartesian (grid) coordinates to isometric screen coordinates.
 * In isometric projection:
 *   screenX = (cartX - cartY) * (tileWidth / 2)
 *   screenY = (cartX + cartY) * (tileHeight / 2)
 */
export function cartToIso(cartX, cartY) {
  return {
    x: (cartX - cartY) * (TILE_WIDTH / 2),
    y: (cartX + cartY) * (TILE_HEIGHT / 2),
  };
}

/**
 * Convert isometric screen coordinates back to cartesian (grid) coordinates.
 */
export function isoToCart(isoX, isoY) {
  return {
    x: (isoX / (TILE_WIDTH / 2) + isoY / (TILE_HEIGHT / 2)) / 2,
    y: (isoY / (TILE_HEIGHT / 2) - isoX / (TILE_WIDTH / 2)) / 2,
  };
}

/**
 * Convert a tile grid position to its world-screen centre point.
 */
export function tileToWorld(tileX, tileY) {
  return cartToIso(tileX, tileY);
}

/**
 * Compute the depth sorting value for an isometric object.
 * Objects with higher cartesian sum (x+y) are further "down" on screen
 * and should render on top.
 */
export function isoDepth(cartX, cartY) {
  return cartX + cartY;
}
